import { render, staticRenderFns } from "./VolunteerProfileNeeds.vue?vue&type=template&id=6627c538"
import script from "./VolunteerProfileNeeds.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports